import { intl } from 'di18n-react';
import auth from '@/utils/authentication';
import { useEffect, useMemo, useState } from 'react';
export const routes = [
// {
//   name: '首页',
//   key: 'home',
// },
{
  name: intl.t('设备管理'),
  key: 'device',
  children: [{
    name: intl.t('设备列表'),
    key: 'nms/device/index'
  }, {
    name: intl.t('设备详情'),
    key: 'nms/device/detail'
  }, {
    name: 'OTA',
    key: 'nms/device/ota'
  }, {
    name: 'FOTA',
    key: 'nms/device/fota'
  }]
}, {
  name: intl.t('告警管理'),
  key: 'alarm',
  children: [{
    name: intl.t('事件监控'),
    key: 'nms/alarm/monitor'
  }]
}, {
  name: intl.t('数据分析'),
  key: 'resourcemonitoring',
  children: [{
    name: intl.t('资源监控'),
    key: 'nms/analysis/monitor'
  }]
}, {
  name: intl.t('应用管理'),
  key: 'application',
  children: [{
    name: intl.t('应用中心'),
    key: 'nms/application/appcenter'
  }, {
    name: intl.t('部署记录'),
    key: 'nms/application/appdeploy'
  }, {
    name: intl.t('应用状态'),
    key: 'nms/application/appstate'
  }]
}, {
  name: intl.t('配置管理'),
  key: 'remote',
  children: [{
    name: intl.t('远程文件'),
    key: 'nms/remote/file'
  }, {
    name: intl.t('远程命令'),
    key: 'nms/remote/command'
  }]
}];
export const getName = (path, routes) => {
  return routes.find(item => {
    const itemPath = `/${item.key}`;
    if (path === itemPath) {
      return item.name;
    } else if (item.children) {
      return getName(path, item.children);
    }
  });
};
export const generatePermission = role => {
  const actions = role === 'admin' ? ['*'] : ['read'];
  const result = {};
  routes.forEach(item => {
    if (item.children) {
      item.children.forEach(child => {
        result[child.name] = actions;
      });
    }
  });
  return result;
};
const useRoute = userPermission => {
  const filterRoute = (routes, arr = []) => {
    if (!routes.length) {
      return [];
    }
    for (const route of routes) {
      const {
        requiredPermissions,
        oneOfPerm
      } = route;
      let visible = true;
      if (requiredPermissions) {
        visible = auth({
          requiredPermissions,
          oneOfPerm
        }, userPermission);
      }
      if (!visible) {
        continue;
      }
      if (route.children && route.children.length) {
        const newRoute = {
          ...route,
          children: []
        };
        filterRoute(route.children, newRoute.children);
        if (newRoute.children.length) {
          arr.push(newRoute);
        }
      } else {
        arr.push({
          ...route
        });
      }
    }
    return arr;
  };
  const [permissionRoute, setPermissionRoute] = useState(routes);
  useEffect(() => {
    const newRoutes = filterRoute(routes);
    setPermissionRoute(newRoutes);
  }, [userPermission]);
  const defaultRoute = useMemo(() => {
    const first = permissionRoute[0];
    if (first) {
      const firstRoute = first?.children?.[0]?.key || first.key;
      return firstRoute;
    }
    return '';
  }, [permissionRoute]);
  return [permissionRoute, defaultRoute];
};
export default useRoute;